import { ConnectedPosition } from '@angular/cdk/overlay';

export enum TooltipPosition {
    NORTH = 'north',
    NORTHEAST = 'northeast',
    NORTHWEST = 'northwest',
    SOUTH = 'south',
    SOUTHEAST = 'southeast',
    SOUTHWEST = 'southwest',
}

export const TooltipPositioning: {
    [key: string]: ConnectedPosition;
} = {
    [TooltipPosition.NORTH]: {
        originX: 'center',
        originY: 'top',
        overlayX: 'center',
        overlayY: 'bottom'
    },
    [TooltipPosition.NORTHEAST]: {
        originX: 'end',
        originY: 'top',
        overlayX: 'end',
        overlayY: 'bottom'
    },
    [TooltipPosition.NORTHWEST]: {
        originX: 'start',
        originY: 'top',
        overlayX: 'start',
        overlayY: 'bottom'
    },
    [TooltipPosition.SOUTH]: {
        originX: 'center',
        originY: 'bottom',
        overlayX: 'center',
        overlayY: 'top'
    },
    [TooltipPosition.SOUTHEAST]: {
        originX: 'end',
        originY: 'bottom',
        overlayX: 'end',
        overlayY: 'top'
    },
    [TooltipPosition.SOUTHWEST]: {
        originX: 'start',
        originY: 'bottom',
        overlayX: 'start',
        overlayY: 'top'
    },
};
